export default __webpack_public_path__ + "static/media/office-profi.9a9f43f1.jpg";